import WeightInputValidation from './WeightInputValidation';

export default WeightInputValidation;
